import { navigateWithHref } from "shared/helper/serviceLauncher";
import { MSG_ERRO_SERVIDOR } from "../../../shared/constantes/mensagens";
import { obterMensagemErroResponse } from "../../../shared/helper/RequestUtil";
import { postSeguro, putSeguroPromise, getSeguro } from "../../../shared/helper/requests";
import { obterCampoAdicionalPorSiglaIgnoreCase } from "../disponibilidade/helper";
import { alterCampoAdicional, setRequerimentoInicial } from "../onboarding/actions";
import { SIGLA_CAMPO_ADICIONAL_APS_VAGA_LONGA, SIGLA_CAMPO_ADICIONAL_DATA_PRIMEIRO_AGENDAMENTO_PERICIA, SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA, SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO } from "../selecaoServicos/siglaServico";
import { SITUACAO_PERICIA_PRORROGACAO_AGENDADA, SITUACAO_PERICIA_PRORROGACAO_ERRO_AGENDAR, SITUACAO_PERICIA_PRORROGACAO_SEM_NECESSIDADE, SITUACAO_PERICIA_PRORROGACAO_SEM_VAGA, isCampoAdicionalDataAgendaPericia } from "./helper";
import { obterSiglaTipoPericiaTipoSibe } from "../pericia/helper";

export const iniciarValidacaoProrrogacao = () => ({
  type: "REQUERIMENTO_PRORROGACAO_VALIDAR_SIBE_INICIAR",
});

export const validarProrrogacaoBeneficio = () => {
  return (dispatch, getState) => {
    const requerimentoTO = getState().requerimentos.onboarding.requerimentoTO;
    dispatch(iniciarValidacaoProrrogacao());
    return postSeguro(
      dispatch,
      `SagService/requerente/validarProrrogacaoBeneficio`,
      requerimentoTO,
      (dados) => receberValidacaoProrrogacaoBeneficio(dados, dispatch),
      receberErroValidacaoProrrogacaoBeneficio
    );
  };
}

const receberValidacaoProrrogacaoBeneficio = (requerimentoTO, dispatch) => {
  dispatch(setRequerimento(requerimentoTO));
  if (requerimentoTO?.possuiErros) {
    if (requerimentoTO.urlSabi) {
      navigateWithHref(requerimentoTO.urlSabi)
      return {
        type: "REQUERIMENTO_PRORROGACAO_VALIDAR_SIBE_ERRO",
        payload: Array.isArray(requerimentoTO.erros) ? requerimentoTO.erros[0] + " Você será redirecionado para realizar este requerimento pelo sistema SABI" : MSG_ERRO_SERVIDOR,
      }
    }    
    return {
      type: "REQUERIMENTO_PRORROGACAO_VALIDAR_SIBE_ERRO",
      payload: Array.isArray(requerimentoTO.erros) ? requerimentoTO.erros[0] : MSG_ERRO_SERVIDOR,
    }
  } else {
    return {
      type: "REQUERIMENTO_PRORROGACAO_VALIDAR_SIBE_SUCESSO",
      payload: requerimentoTO
    }
  }
}

const receberErroValidacaoProrrogacaoBeneficio = (erro) => {
  return {
    type: "REQUERIMENTO_PRORROGACAO_VALIDAR_SIBE_ERRO",
    payload: obterMensagemErroResponse(erro),
  };
};

export const selecionarBeneficioParaProrrogacao = (beneficio) => {
  return {
    type: "REQUERIMENTO_PRORROGACAO_SELECIONAR_BENEFICIO",
    payload: beneficio
  };
};

export const exibirAlertaProrrogacao = alerta => {
  return ({
    type: "REQUERIMENTO_PRORROGACAO_EXIBIR_ALERTA",
    payload: alerta
  })
}

export const fecharAlertaProrrogacao = () => ({
  type: "REQUERIMENTO_PRORROGACAO_FECHAR_ALERTA",
});

export const iniciarConclusaoProrrogacao = () => ({
  type: "REQUERIMENTO_PRORROGACAO_CONCLUIR_PEDIDO_INICIAR",
});

export const finalizarConclusaoProrrogacao = () => ({
  type: "REQUERIMENTO_PRORROGACAO_CONCLUIR_PEDIDO_FINALIZAR",
});

const setRequerimento = (requerimentoTO) => {
  return (dispatch, getState) => {
    const requerimentoTOLocal = getState().requerimentos.onboarding.requerimentoTO;
    requerimentoTO.etapas = requerimentoTOLocal.etapas;
    return dispatch(setRequerimentoInicial(requerimentoTO))
  }
}

export const setRequerimentoProrrogacao = requerimentoTO => {
  return {
    type: 'REQUERIMENTO_PRORROGACAO_SET_RETORNO',
    payload: requerimentoTO
  }
}

const atualizarInformacaoAgendaPericia = (siglaCampoAdicional, valorCampoAdicional) => {
  return (dispatch, getState) => {
    const requerimentoTO = getState().requerimentos.onboarding.requerimentoTO;
    let campoAdicionalAgendaPericia = obterCampoAdicionalPorSiglaIgnoreCase(
      requerimentoTO?.dadosAdicionais, siglaCampoAdicional);
    if (campoAdicionalAgendaPericia) {
      return dispatch(alterCampoAdicional(
        valorCampoAdicional,
        campoAdicionalAgendaPericia.id));
    }
  };
}

export const atualizarSituacaoSemNecessidadeAgendarPericia = () => {
  return atualizarInformacaoAgendaPericia(
    SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA,
    SITUACAO_PERICIA_PRORROGACAO_SEM_NECESSIDADE);
}

export const atualizarSituacaoErroAgendarPericia = () => {
  return atualizarInformacaoAgendaPericia(
    SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA,
    SITUACAO_PERICIA_PRORROGACAO_ERRO_AGENDAR);
}

export const atualizarSituacaoSemVagaAgendarPericia = () => {
  return atualizarInformacaoAgendaPericia(
    SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA,
    SITUACAO_PERICIA_PRORROGACAO_SEM_VAGA);
}

export const atualizarSituacaoAgendadaPericia = () => {
  return atualizarInformacaoAgendaPericia(
    SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA,
    SITUACAO_PERICIA_PRORROGACAO_AGENDADA);
}

export const atualizarDataAgendadaPericia = (vagaAgenda) => {
  if (vagaAgenda?.dataHora) {
    return atualizarInformacaoAgendaPericia(
      SIGLA_CAMPO_ADICIONAL_DATA_PRIMEIRO_AGENDAMENTO_PERICIA,
      vagaAgenda.dataHora);
  }
}

export const atualizarTipoPericiaSemValor = () => {
  return atualizarInformacaoAgendaPericia(
    SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO,
    null);
}

export const atualizarCamposAdicionais = () => {

  return (dispatch, getState) => {

    const requerimento = getState().requerimentos.onboarding.requerimentoTO;

    if (requerimento?.protocoloRequerimento) {

      let camposAdicionaisParaAtualizacao = requerimento?.dadosAdicionais?.
        map((campoAdicional) => (
          {
            ...campoAdicional,
            conteudo: isCampoAdicionalDataAgendaPericia(campoAdicional) ?
              campoAdicional.valorComMascara : campoAdicional.valor
          })
        );

      const tarefaComCamposAdicionaisParaEdicaoTO = {
        numeroProtocolo: requerimento?.protocoloRequerimento,
        cpfSolicitante: requerimento?.dadosRequerente.cpf,
        nomeSolicitante: requerimento?.dadosRequerente.nome,
        camposAdicionais: camposAdicionaisParaAtualizacao,
        nomeSistemaBatch: 'MEU_INSS',
        canalAtendimento: 'INTERNET'
      }

      return putSeguroPromise(
        `SagService/tarefa/${requerimento?.protocoloRequerimento}/campos`,
        tarefaComCamposAdicionaisParaEdicaoTO)
        .then(response => {
          return dispatch(receberSucessoAtualizaCamposAdicionais(requerimento?.dadosAdicionais))
        })
        .catch(erro => {
          return dispatch(receberErroAtualizaCamposAdicionais(erro))
        })

    }

  }


}


export const atualizarCamposAdicionaisPPTarefa = (tarefa, situacaoAgendamento, dataPrimeiroAgendamento, tipoPP, APSVagaDistante) => {

  return () => {

    if (tarefa?.numeroProtocolo ) {

      let camposAdicionaisParaAtualizacao = [
        {
          conteudo: situacaoAgendamento,
          sigla: SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA
        },
        {
          conteudo: obterSiglaTipoPericiaTipoSibe(tipoPP),
          sigla: SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO
        }
      ]

      if (dataPrimeiroAgendamento) {
        camposAdicionaisParaAtualizacao.push({
          conteudo: dataPrimeiroAgendamento,
          sigla: SIGLA_CAMPO_ADICIONAL_DATA_PRIMEIRO_AGENDAMENTO_PERICIA
        });
      }

      if (APSVagaDistante) {
        camposAdicionaisParaAtualizacao.push({
          conteudo: APSVagaDistante,
          sigla: SIGLA_CAMPO_ADICIONAL_APS_VAGA_LONGA
        });
      }

      let requerente = Array.isArray(tarefa?.interessadosPessoaFisica) ? tarefa?.interessadosPessoaFisica[0] : null;

      const tarefaComCamposAdicionaisParaEdicaoTO = {
        numeroProtocolo: tarefa?.numeroProtocolo,
        cpfSolicitante: requerente.cpf,
        nomeSolicitante: requerente.nome,
        camposAdicionais: camposAdicionaisParaAtualizacao,
        nomeSistemaBatch: 'MEU_INSS',
        canalAtendimento: 'INTERNET'
      }

      return putSeguroPromise(
        `SagService/tarefa/${tarefa?.numeroProtocolo}/campos`,
        tarefaComCamposAdicionaisParaEdicaoTO)
        .then(response => {
          return {
            type: "ATUALIZACAO_CAMPOS_ADICIONAIS_SUCESSO",
            data: response.data,
          }
        })
        .catch(erro => {
          return {
            type: "ATUALIZACAO_CAMPOS_ADICIONAIS_ERRO",
            data: erro,
          }
        })

    }

  }

}

const receberErroAtualizaCamposAdicionais = (erro) => {
  return {
    type: "REQUERIMENTO_PRORROGACAO_ATUALIZA_CAMPOS_ERRO",
    payload: obterMensagemErroResponse(erro),
  };
};

const receberSucessoAtualizaCamposAdicionais = (dadosAdicionais) => {
  return {
    type: "REQUERIMENTO_PRORROGACAO_ATUALIZA_CAMPOS_SUCESSO",
    payload: dadosAdicionais,
  };
};

export const consultarListaDeBeneficiosParaProrrogacao = (cpf, servico) => {
  return function (dispatch) {
    dispatch(iniciaConsultarListaDeBeneficiosParaProrrogacao());
    return getSeguro(
      dispatch,
      `SagService/requerente/${cpf}/consultarListaDeBeneficiosParaProrrogacao?idServico=${servico.id}`,
      consultarListaDeBeneficiosParaProrrogacaoSucesso,
      consultarListaDeBeneficiosParaProrrogacaoErro
    );
  }
}

export const iniciaConsultarListaDeBeneficiosParaProrrogacao = () => ({
  type: 'CONSULTAR_LISTA_BENEFICIOS_PARA_PRORROGACAO_INICIAR'
})

export const consultarListaDeBeneficiosParaProrrogacaoSucesso = (beneficios) => {
  return {
    type: "CONSULTAR_LISTA_BENEFICIOS_PARA_PRORROGACAO_SUCESSO",
    payload: beneficios,
  };
}

const consultarListaDeBeneficiosParaProrrogacaoErro = (erro) => {
  return {
    type: "CONSULTAR_LISTA_BENEFICIOS_PARA_PRORROGACAO_ERRO",
    payload: obterMensagemErroResponse(erro),
  };
}

export const setTemVagasPman = temVagasPman => {
  return {
    type: 'PRORROGACAO_TEM_VAGAS_PMAN',
    payload: temVagasPman
  }
}

export const consultarListaDeBeneficiosParaProrrogacaoFim = () => {
  return {
    type: "CONSULTAR_LISTA_BENEFICIOS_PARA_PRORROGACAO_FIM"
  };
}
